var u = Object.defineProperty;
var m = (e, r, t) => r in e ? u(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var d = (e, r, t) => (m(e, typeof r != "symbol" ? r + "" : r, t), t);
import { guardExist as Y } from "@smh/utils/guards";
import { isBrowser as v } from "@smh/utils/is-in-browser";
import l, { extend as D, locale as g } from "dayjs";
import H from "dayjs/locale/ru";
import $ from "dayjs/plugin/customParseFormat";
import h from "dayjs/plugin/duration";
class f extends Error {
  constructor(t) {
    super();
    d(this, "message");
    this.message = t;
  }
}
D($);
g(H);
const w = 365.24, A = 864e5, S = 1e3, b = [
  "ddd, DD MMM YYYY HH:mm:ss [GMT]",
  "YYYY",
  "YYYY-MM-DD",
  "DD.MM.YYYY",
  "DD MMMM YYYY",
  "DD MMM YYYY",
  "YYYY-MM-DD HH:mm",
  "DD.MM.YYYY HH:mm",
  "DD MMMM YYYY HH:mm",
  "DD MMM YYYY HH:mm",
  "YYYY-MM-DD HH:mm:ss",
  "DD.MM.YYYY HH:mm:ss",
  "DD MMMM YYYY HH:mm:ss",
  "DD MMM YYYY HH:mm:ss"
], F = (e) => {
  const r = new Date(e), t = 6e4, a = r.getTimezoneOffset() * t;
  return new Date(r.getTime() + a);
}, I = () => {
  const r = navigator.userAgent.toLowerCase(), t = new RegExp(".*version/([^.]+).*").exec(r), a = t !== null ? Number(t[1]) : 14;
  return /safari/.test(navigator.userAgent.toLowerCase()) && a < 14 && !/chrome/.test(navigator.userAgent.toLowerCase());
}, E = () => v() ? I() : !1, n = (e, r) => {
  var t;
  if (typeof e == "string") {
    const a = (t = r == null ? void 0 : r.dateFormats) != null ? t : [], i = [...b, ...a], o = l(e, i, "ru", !0), c = l(e, i, "en", !0);
    return o.isValid() ? o : c;
  }
  return l(e);
}, s = (e, r, t) => {
  if (!N(e, t))
    throw new f(r);
}, N = (e, r) => n(e, r).isValid(), M = (e, r = "YYYY-MM-DD", t) => {
  s(e, "date is invalid", t);
  const a = E() ? F(e) : e;
  return n(a, t).format(r);
}, T = (e, r, t) => {
  s(e, "dateEnd is invalid", t), s(r, "dateStart is invalid", t);
  const a = n(M(e), t).valueOf(), i = n(M(r), t).valueOf();
  return Math.floor(Math.abs((a - i) / A));
}, k = (e, r, t) => {
  s(e, "dateEnd is invalid", t), s(r, "dateStart is invalid", t);
  const a = T(e, r, t);
  return Math.floor(a / w);
}, y = (e, r, t) => {
  s(e, "dateEnd is invalid", t), s(r, "dateStart is invalid", t);
  const a = n(e, t).valueOf(), i = n(r, t).valueOf();
  return Math.floor(Math.abs((a - i) / S));
}, U = (e, r, t, a) => (s(e, "date is invalid", a), s(r, "dateToCompare is invalid", a), n(e, a).isBefore(r, t)), j = (e, r, t, a) => (s(e, "date is invalid", a), s(r, "dateToCompare is invalid", a), n(e, a).isSame(r, t)), G = (e, r, t, a) => (s(e, "date is invalid", a), s(r, "dateToCompare is invalid", a), n(e, a).isAfter(r, t)), W = (e, r, t = "YYYY-MM-DD", a) => {
  if (s(e, "date is invalid", a), !Y(r.value))
    throw new f("duration value in invalid");
  if (!Y(r.unit))
    throw new f("duration unit in invalid");
  return n(e, a).subtract(r.value, r.unit).format(t);
}, V = (e, r) => (s(e, "date is invalid", r), n(e, r).daysInMonth()), q = (e, r = !0, t) => (s(e, "date is invalid", t), r ? M(e, "D MMM YYYY \u0432 HH:mm", t).replace(".", "") : M(e, "D MMM YYYY", t).replace(".", "")), J = (e, r, t) => {
  if (s(e, "year is invalid"), Y(t) && Y(r))
    return s(`01.${r}.${e}`, "month is invalid"), s(`${t}.${r}.${e}`, "day is invalid"), {
      dateFrom: `${t}.${r}.${e}`,
      dateTo: `${t}.${r}.${e}`,
      type: "day"
    };
  if (Y(r)) {
    s(`01.${r}.${e}`, "month is invalid");
    const a = Number(e), i = Number(r), o = V(new Date(a, i - 1));
    return {
      dateFrom: `01.${r}.${e}`,
      dateTo: `${o}.${r}.${e}`,
      type: "month"
    };
  }
  return {
    dateFrom: `01.01.${e}`,
    dateTo: `31.12.${e}`,
    type: "year"
  };
};
class x extends Error {
  constructor(t) {
    super();
    d(this, "message");
    this.message = t;
  }
}
const K = (e) => {
  if (e > 0)
    return D(h), l.duration(e, "seconds").format("HH:mm:ss").replace(/^00:/, "");
  throw new x(
    "duration value must be greater than zero"
  );
};
export {
  f as UtilDateInvalidDateArgumentError,
  x as UtilDateInvalidFormatDurationArgumentError,
  M as dateFormat,
  V as daysInMonth,
  T as differenceInCalendarDays,
  y as differenceInSeconds,
  k as differenceInYears,
  q as formatDateWithMonthName,
  K as formatDurationFromSeconds,
  J as getDateRange,
  G as isAfter,
  U as isBefore,
  j as isSame,
  N as isValidDate,
  W as subtract
};
